// extracted by mini-css-extract-plugin
export var ToggleMenu = "togglemenu-module--ToggleMenu--2LGg1";
export var ToggleMenuShown = "togglemenu-module--ToggleMenuShown--39AwR";
export var CloseButton = "togglemenu-module--CloseButton--3cMRr";